import { isNil } from 'lodash';

export type PropsHelper<T> = {
  [key: string]: any;

  getProps(): T;
  setProps(): void;
  propsChanged(): boolean;
};

export function buildPropsHelper<T extends object>(): PropsHelper<T> {
  return {
    getProps(): T {
      throw new Error('You must implement this function in your Hook');
    },

    setProps() {
      const props = this.getProps();
      for (const [key, value] of Object.entries(props)) {
        this[key] = value;
      }
    },

    propsChanged() {
      const props = this.getProps();

      for (const [key, value] of Object.entries(props)) {
        if (!isNil(this[key]) && this[key] !== value) {
          return true;
        }
      }

      return false;
    },
  };
}
